// extracted by mini-css-extract-plugin
module.exports = {"charge":"charge_charge__1ApWn","charges":"charge_charges__1k69g","content":"charge_content__fGB_o","total":"charge_total__2Rs8i","footingTitle":"charge_footingTitle__1mbLu"};